import React, {Component} from 'react';
import {Geo} from "aws-amplify";
import AutoCompletePopup from "./AutoCompletePopup";
import { Popover } from 'react-tiny-popover'
import PropTypes from "prop-types";
import {Form} from "react-bootstrap";
class Address extends Component {

    constructor(props) {
        super(props);
        this.wordsMin = 2
        this.wordsMax = 5
        this.state = {
            fetchingResults: false,
            results: [],
            suggestions: [],
            defaultValue: this.props.elementProps.defaultValue || ''
        }
        this.input = React.createRef()
    }
    componentDidMount() {
        if (this.props?.autoFocus && this.input.current){
            this.input.current.focus()
        }
    }
    updateSuggestions = () => {
        if (this.state.results.length){
            let value = this.state.defaultValue
            if (value.length > 0) {
                const regex = new RegExp(`^${value.trim()}`, `i`);
                this.setState(prevState => {
                    return {
                        ...prevState,
                        suggestions: prevState.results.filter(v => {
                            return regex.test(v.label)
                        })
                    }
                })
            }
        }
    }
    getItems = async function (v) {
        const results = await Geo.searchByText(v, {
            countries: ["IRL"], // Alpha-3 country codes
            maxResults: 50, // 50 is the max and the default
        })
        return results.map(item=>{
            const parts = item.label.split(/[ ]+/);
            parts.length = Math.min(parts.length, 3);
            return {
                label:parts.join(' ').replace(/,\s*$/, ""),
                text:item.label,
                value:item.label
            }
        })
    }
    getResults = async function () {
        if (!this.state.fetchingResults) {
            const self = this
            this.setState({fetchingResults: true},()=>{
                self.getItems(this.state.defaultValue).then(results=>{
                    self.setState({results:results, fetchingResults: false},()=>{
                        self.updateSuggestions()
                    })
                })
            })
        }
    }
    elementProps() {
        const {setAnswer, getItems, address, defaultValue, ...elementProps} = this.props.elementProps
        const self = this
        elementProps.onChange = (e) =>{
            this.setState({defaultValue:e.target.value},()=>{
                let words = this.state.defaultValue.split(" ")
                if (words.length > self.wordsMin && words.length < self.wordsMax && !self.state.fetchingResults && !self.state.suggestions.length) {
                    self.getResults()
                } else {
                    self.updateSuggestions()
                }
            })
        }
        elementProps.onKeyUp = function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                return e.target.blur()
            }
        }
        elementProps.onBlur = (e)=>{
            if (this.state.suggestions.length === 0){
                this.props.setAnswer(e.target.value)
            }
        }
        if (this.props?.autoFocus){
           // elementProps.autoFocus=true
        }
        return elementProps
    }
    handlePopupSelection = (value)=>{
        this.setState(prevState=>{
            return{
                suggestions:[],
                inputRenderKey: prevState.inputRenderKey + 1,
                defaultValue: value
            }
        },()=>{
            this.props.setAnswer(this.state.defaultValue)
        })
    }
    renderSuggestions() {
        if (this.state.suggestions.length === 0) {
            return null;
        }
        return <AutoCompletePopup handleSelection={this.handlePopupSelection} address={true} suggestions={this.state.suggestions}/>
    }
    render = ()=>{
        return <Popover
            align="start"
            isOpen={this.state.suggestions.length > 0}
            positions={['bottom','top','left', 'right']} // preferred positions by priority
            content= {this.renderSuggestions()}
        >
            <Form.Control ref={this.input} value={this.state.defaultValue} type="text" {...this.elementProps()} />
        </Popover>;
    }
}

export default Address;
Address.propTypes = {
    elementProps: PropTypes.object,
    setAnswer: PropTypes.func,
};